module.exports = `${require.publicPath}empty_img.c1fc764f.png`;